<template>
  <v-container fluid class="business-info-page">
    <div class="content-wrapper">
      <div class="d-flex align-center mb-8">
        <h1 class="text-h3 font-weight-light">{{ $t('global.businessInfo.title') }}</h1>
        <div class="language-selector ml-4">
          <LocaleSelect />
        </div>
      </div>

      <v-row>
        <v-col cols="12" lg="12" xl="12">
          <!-- Czech Office Information -->
          <div class="office-section mb-12">
            <h2 class="text-h5 font-weight-regular mb-6">
              {{ $t('global.businessInfo.czechOffice.name') }}
            </h2>
            <div class="info-section">
              <div class="info-group">
                <h3>{{ $t('global.businessInfo.companyName') }}</h3>
                <p>Eledio s.r.o.</p>
              </div>

              <div class="info-group">
                <h3>{{ $t('global.businessInfo.address') }}</h3>
                <p>Golčova 485</p>
                <p>148 00 Praha</p>
                <p>{{ $t('global.businessInfo.czechRepublic') }}</p>
              </div>

              <div class="info-group">
                <h3>{{ $t('global.businessInfo.registration') }}</h3>
                <p>ID: CZ24694631</p>
                <p>VAT ID: CZ24694631</p>
              </div>

              <div class="info-group">
                <h3>{{ $t('global.businessInfo.contact') }}</h3>
                <p>{{ $t('global.businessInfo.email') }}: eledio@eledio.com</p>
                <p>{{ $t('global.businessInfo.phone') }}: +420 602 343 440</p>
              </div>
            </div>
          </div>

          <!-- German Office Information -->
          <!-- <div class="office-section mb-12">
            <h2 class="text-h5 font-weight-regular mb-6">
              {{ $t('global.businessInfo.germanOffice.name') }}
            </h2>
            <div class="info-section">
              <div class="info-group">
                <h3>{{ $t('global.businessInfo.companyName') }}</h3>
                <p>Eledio GmbH</p>
              </div>

              <div class="info-group">
                <h3>{{ $t('global.businessInfo.address') }}</h3>
                <p>Praunheimer Landstraße 32</p>
                <p>D-60484 Frankfurt am Main</p>
                <p>{{ $t('global.businessInfo.germany') }}</p>
              </div>

              <div class="info-group">
                <h3>{{ $t('global.businessInfo.contact') }}</h3>
                <p>{{ $t('global.businessInfo.phone') }}: +49 151 706 895 11</p>
              </div>
            </div>
          </div> -->

          <!-- Legal Links -->
          <div class="legal-section">
            <!-- Terms Sections -->
            <div class="terms-section">
              <!-- Terms and Conditions -->
              <div class="mb-12">
                <h2 class="text-h5 font-weight-regular mb-6">
                  {{ $t('global.businessInfo.termsAndConditions') }}
                </h2>
                <v-expansion-panels>
                  <v-expansion-panel v-for="(item, i) in termsItems" :key="i">
                    <v-expansion-panel-header>
                      {{ $t(item.title) }}
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                      {{ $t(item.content) }}
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
              </div>

              <!-- Return Policy -->
              <div class="mb-12">
                <h2 class="text-h5 font-weight-regular mb-6">
                  {{ $t('global.businessInfo.returnPolicyTitle') }}
                </h2>
                <v-expansion-panels>
                  <v-expansion-panel v-for="(item, i) in returnPolicyItems" :key="i">
                    <v-expansion-panel-header>
                      {{ $t(item.title) }}
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                      {{ $t(item.content) }}
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
              </div>

              <!-- Delivery and Payment -->
              <div class="mb-12">
                <h2 class="text-h5 font-weight-regular mb-6">
                  {{ $t('global.businessInfo.deliveryPaymentTitle') }}
                </h2>
                <v-expansion-panels>
                  <v-expansion-panel v-for="(item, i) in deliveryPaymentItems" :key="i">
                    <v-expansion-panel-header>
                      {{ $t(item.title) }}
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                      {{ $t(item.content) }}
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
              </div>

              <!-- Privacy Policy -->
              <div>
                <h2 class="text-h5 font-weight-regular mb-6">
                  {{ $t('global.businessInfo.privacyPolicyTitle') }}
                </h2>
                <v-expansion-panels>
                  <v-expansion-panel v-for="(item, i) in privacyPolicyItems" :key="i">
                    <v-expansion-panel-header>
                      {{ $t(item.title) }}
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                      {{ $t(item.content) }}
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
              </div>
            </div>
          </div>
        </v-col>
      </v-row>
    </div>
  </v-container>
</template>

<script>
import LocaleSelect from '@/components/LocaleSelect.vue'

export default {
  name: 'BusinessInfo',
  components: {
    LocaleSelect,
  },
  data() {
    return {
      legalLinks: [
        {
          title: 'global.businessInfo.termsAndConditions',
          url: 'https://www.eledio.com/cs/subscription/',
        },
        {
          title: 'global.businessInfo.returnPolicy',
          url: 'https://www.eledio.com/cs/subscription/',
        },
        {
          title: 'global.businessInfo.deliveryAndPayment',
          url: 'https://www.eledio.com/cs/subscription/',
        },
      ],
      termsItems: [
        {
          title: 'global.businessInfo.terms.introductionTitle',
          content: 'global.businessInfo.terms.introductionContent',
        },
        {
          title: 'global.businessInfo.terms.orderTitle',
          content: 'global.businessInfo.terms.orderContent',
        },
        {
          title: 'global.businessInfo.terms.subscriptionTitle',
          content: 'global.businessInfo.terms.subscriptionContent',
        },
        {
          title: 'global.businessInfo.terms.durationTitle',
          content: 'global.businessInfo.terms.durationContent',
        },
      ],
      returnPolicyItems: [
        {
          title: 'global.businessInfo.returnPolicy.rightTitle',
          content: 'global.businessInfo.returnPolicy.rightContent',
        },
        {
          title: 'global.businessInfo.returnPolicy.processTitle',
          content: 'global.businessInfo.returnPolicy.processContent',
        },
        {
          title: 'global.businessInfo.returnPolicy.refundTitle',
          content: 'global.businessInfo.returnPolicy.refundContent',
        },
      ],
      deliveryPaymentItems: [
        {
          title: 'global.businessInfo.deliveryPayment.paymentTitle',
          content: 'global.businessInfo.deliveryPayment.paymentContent',
        },
        {
          title: 'global.businessInfo.deliveryPayment.deliveryTitle',
          content: 'global.businessInfo.deliveryPayment.deliveryContent',
        },
      ],
      privacyPolicyItems: [
        {
          title: 'global.businessInfo.privacyPolicy.dataProcessingTitle',
          content: 'global.businessInfo.privacyPolicy.dataProcessingContent',
        },
        {
          title: 'global.businessInfo.privacyPolicy.securityTitle',
          content: 'global.businessInfo.privacyPolicy.securityContent',
        },
        {
          title: 'global.businessInfo.privacyPolicy.rightsTitle',
          content: 'global.businessInfo.privacyPolicy.rightsContent',
        },
      ],
    }
  },
}
</script>

<style lang="less" scoped>
.business-info-page {
  background-color: #fff;
  color: #212529;
  padding: 64px 0;
  width: 100%;

  .content-wrapper {
    max-width: 1400px;
    margin: 0 auto;
    padding: 0 24px;
    width: 100%;
  }

  h1 {
    color: #000;
    font-size: 2.5rem;
    letter-spacing: -0.5px;
  }

  .office-section {
    position: relative;

    &:after {
      content: '';
      position: absolute;
      bottom: -32px;
      left: 0;
      right: 0;
      height: 1px;
      background-color: #e9ecef;
    }

    &:last-of-type:after {
      display: none;
    }

    h2 {
      color: #000;
      font-size: 1.75rem;
      letter-spacing: -0.3px;
    }
  }

  .info-section {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 1fr;
    gap: 32px;
  }

  .info-group {
    h3 {
      color: #6c757d;
      font-size: 0.875rem;
      font-weight: 500;
      text-transform: uppercase;
      letter-spacing: 0.5px;
      margin-bottom: 8px;
    }

    p {
      color: #212529;
      font-size: 1rem;
      line-height: 1.6;
      margin-bottom: 4px;

      &:last-child {
        margin-bottom: 0;
      }
    }
  }

  .legal-section {
    padding-top: 32px;
  }

  .legal-links {
    display: flex;
    flex-wrap: wrap;
    gap: 32px;

    .legal-link {
      color: #00a3ff;
      text-decoration: none;
      font-size: 1rem;
      display: flex;
      align-items: center;
      transition: color 0.2s ease;

      &:hover {
        color: #0082cc;
      }

      .v-icon {
        font-size: 16px;
        opacity: 0.7;
      }
    }
  }

  .terms-section {
    margin: 0 auto;

    .v-expansion-panels {
      background: transparent;
      width: 100%;

      .v-expansion-panel {
        background: transparent;
        margin-bottom: 8px;
        width: 100%;

        &::before {
          box-shadow: none;
        }

        .v-expansion-panel-header {
          padding: 16px 0;
          min-height: auto;
          font-weight: 500;
          color: #000;
          border-top: 1px solid #e9ecef;

          &::before {
            display: none;
          }
        }

        .v-expansion-panel-content {
          padding: 24px 0;
          color: #495057;
          line-height: 1.6;
          width: 100%;

          &__wrap {
            padding: 0;
          }
        }

        &:last-child {
          border-bottom: 1px solid #e9ecef;
        }
      }
    }
  }
}

// Responsive adjustments
@media (max-width: 959px) {
  .business-info-page {
    padding: 48px 0;

    .content-wrapper {
      padding: 0 16px;
    }

    .terms-section {
      max-width: 100%;
    }

    h1 {
      font-size: 2rem;
    }

    h2 {
      font-size: 1.5rem;
    }

    .info-section {
      grid-template-columns: 1fr;
      gap: 24px;
    }

    .legal-links {
      gap: 24px;
    }
  }
}

@media (max-width: 599px) {
  .business-info-page {
    padding: 32px 0;

    .content-wrapper {
      padding: 0 16px;
    }

    h1 {
      font-size: 1.75rem;
    }

    h2 {
      font-size: 1.25rem;
    }
  }
}
</style>
